import { getMonthOrder } from '@exam-center/exam-event-management';
import { dayjs } from '@shared/utils';
import { useMemo } from 'react';

interface UseGetDefaultDateRangeProps {
  month: string;
  year: string;
}

export default function UseGetDefaultDateRange(props: Readonly<UseGetDefaultDateRangeProps>) {
  const { month, year } = props;

  const defaultDateRange = useMemo<[Date, Date]>(() => {
    const currentDatePeriod = dayjs()
      .set('month', getMonthOrder(month))
      .set('year', parseInt(year));
    const minStartedAt = currentDatePeriod.startOf('month').toDate();
    const maxEndedAt = currentDatePeriod.endOf('month').toDate();

    return [minStartedAt, maxEndedAt];
  }, [month, year]);

  return defaultDateRange;
}
